import { put, select } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import ip6addr from 'ip6addr'

export function* getSpeedBoostCheckDevicesSaga(action) {
  // console.log('get advanced device start', action);
  yield put(actions.getSpeedBoostCheckDevicesLoading());
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const speedBoostOptions = yield sessionStorage.getItem('speedBoost') || '';
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/getSpeedBoostDevices' + speedBoostOptions,
        {
          rMac: rMac,
          bToken: token,
          deviceMac: action.deviceMac,
          sessionToken: sessionToken,
        }
      );

      // console.log(response, 'respon kk', response.data);

      if (response.status === 200) {
        // console.log('get speed boost check device end', response);

        yield put(
          actions.getSpeedBoostCheckDevicesSuccess(
            response.data.speedBoostDevices
          )
        );
      } else {
        // console.log('GET speed boost check DEVICE FAILED');
        yield put(actions.getSpeedBoostCheckDevicesFailure());
      }
    } catch (error) {
      // console.error('GET ADVANCED DEVICE FAILED', error);
      yield put(actions.getSpeedBoostCheckDevicesFailure(action));
    }
  } else {
    //console.log('NO TOKEN');
    yield put(actions.getSpeedBoostCheckDevicesFailure(action));
  }
}

export function* initSpeedBoostLogsSaga(action) {
  const speedBoostOptions = yield sessionStorage.getItem('speedBoost') || '';
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const divId = yield sessionStorage.getItem('divId');
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const getDevices = (state) => state.devices.realDevices;
  const devices = yield select(getDevices);

  if (sessionToken) {
    yield put(actions.initSpeedBoostLogsStart());
    try {
      let response = {};
      response = yield axios
        .post('/getSpeedBoostLogs' + speedBoostOptions, {
          accountNumber: accountNumber,
          divId: divId,
          sessionToken: sessionToken,
        })
        .then((res) => {
          let parsedData = res.data;
          // console.log('SB parsedData', parsedData);
          if (Array.isArray(parsedData)) {
            // Parse codes
            return parsedData;
          } else {
            return [];
          }
        });
      yield response.forEach((el, ind, arr) => {
        el.congestionFailure = false;
        el.additionalAttributes.forEach((jl, jnd, jrr) => {
          if (jl.attribute === 'mobileClientIPv6') {
            el.ipv6 = minifyIpv6(jl.value);
          }
          if(jl.attribute === 'failedWSBEligibility' && jl.value.includes('WSBP-019')){
            el.congestionFailure = true;
          }
        });
      });
      if (devices && devices.length) {
        yield devices.filter(x => x.ipv6 && x.ipv6.length).forEach((jl) => {
          response.forEach((el, ind, arr) => {
            if (jl.ipv6[0] && (minifyIpv6(jl.ipv6[0]) === el.ipv6)) {
              el.name = jl.name;
            }
          });
        });
      }

      yield put(actions.setSpeedBoostLogs(response));
    } catch (error) {
      // console.log('fAILEDD')
      yield put(actions.fetchSpeedBoostLogsFailed());
    }
  } else {
    //console.log('NO TOKEN');
  }
}

const minifyIpv6 = (ipv6) => ipv6 ? ip6addr.parse(ipv6).toString() : ''
